import { Spinner } from "@swivl-mono/ui";
import { MouseEventHandler } from "react";
import { RiCheckFill, RiSave3Line } from "react-icons/ri";

import "./EditorSaveButton.scss";

interface Props {
  isDirty: boolean;
  isSaving: boolean;
  save: MouseEventHandler | undefined;
  canEdit: boolean;
}
export function EditorSaveButton(props: Props) {
  const { isDirty, isSaving, save, canEdit } = props;
  if (!canEdit) {
    return null;
  }
  let content;
  if (isSaving) {
    content = <Spinner />;
  } else if (isDirty) {
    content = (
      <>
        <RiSave3Line />
        <span>SAVE</span>
      </>
    );
  } else {
    content = (
      <>
        <RiCheckFill />
        <span>SAVED</span>
      </>
    );
  }

  return (
    <div className={isDirty || isSaving ? "EditorSaveButton show" : "EditorSaveButton hide"} onClick={isDirty && !isSaving ? save : undefined}>
      {content}
    </div>
  );
}
